import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const OtherTransactionWrapper = styled.div`
  margin: -30px 0 0 0;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 10px;
  }
`;

export const StyledOtherTransactionCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;
`;

export const StyledOtherTransactionIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.primaryAkbankWhite} !important;
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 0px 1px;
  padding: 10px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin: 15px 0;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 5px 0;
    width: 45px;
    height: 45px;
  }
  
}
`;
